import { createRouter, createWebHistory } from 'vue-router'

import store from '@/store'
import { SET_MENU } from '@/store/mutation-types'

const base = process.env.VUE_APP_BASE_URL

const routes = [
  {
    path: '/okr',
    name: 'MyOkr',
    component: () => import(/* webpackChunkName: "okr-list" */ '@/views/OkrList'),
    meta: {
      menu: {
        key: 'MY_OKR'
      }
    }
  },
  {
    path: '/okr-week/',
    name: 'MyOkrWeek',
    component: () => import(/* webpackChunkName: "okr-list" */ '@/views/OkrWeek'),
    meta: {
      menu: {
        key: 'MY_OKR'
      }
    }
  },
  {
    path: '/my-team-okr-week/:userId?',
    name: 'MyTeamOkrWeek',
    component: () => import('@/views/MyTeamOkrWeek'),
    meta: {
      menu: {
        key: 'MY_TEAM_OKR_WEEK'
      }
    },
    props: route => ({
      userId: route.params.userId && +route.params.userId
    })
  },
  {
    path: '/okr-week/:userId',
    name: 'UserOkrWeek',
    component: () => import(/* webpackChunkName: "okr-list" */ '@/views/OkrWeek'),
    props: route => ({
      userId: route.params.userId && +route.params.userId
    })
  },
  {
    path: '/users/:userId/okr',
    name: 'UserOkr',
    component: () => import('@/views/OkrList'),
    props: route => ({
      userId: route.params.userId && +route.params.userId
    })
  },
  {
    path: '/alignment-map',
    name: 'AlignmentMap',
    component: () => import(/* webpackChunkName: "coming-soon" */ '@/components/ComingSoon'),
    props: {
      image: require('@/assets/images/coming-soon.png'),
      url: '/okr/home/targetMap'
    },
    meta: {
      menu: {
        key: 'ALIGNMENT_MAP'
      }
    }
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: () => import(/* webpackChunkName: "statistics" */ '@/views/Statistics'),
    meta: {
      menu: {
        key: 'SUMMARY',
        parentKey: 'STATISTICS'
      }
    }
  },
  {
    path: '/statistic-department',
    name: 'StatisticDepartment',
    component: () => import(/* webpackChunkName: "statistic-department" */ '@/views/DepartmentStatistic'),
    meta: {
      menu: {
        key: 'DEPARTMENTS_CHART',
        parentKey: 'STATISTICS'
      }
    }
  },
  {
    path: '/',
    redirect: {
      name: 'MyOkr'
    }
  },
  // 以下路由配置是为了兼容旧版和移动端
  {
    path: '/users/:userId/okr-list',
    redirect: {
      name: 'UserOkr'
    }
  },
  {
    path: '/objectives/:objectiveId',
    redirect: to => ({
      name: 'UserOkr',
      params: {
        userId: to.query.userId
      }
    })
  },
  {
    path: '/aligned-okr/:statementId',
    redirect: {
      name: 'MyOkr'
    }
  },
  {
    path: '/objective-list',
    redirect: {
      name: 'MyOkr'
    }
  },
  // 404
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "NotFound" */ '@/views/NotFound')
  }
]

const router = createRouter({
  history: createWebHistory(base),
  routes
})

router.beforeEach((to, from) => {
  // 兼容原来的 hash 模式路由
  if (to.fullPath.substr(0, 2) === '/#') {
    const path = to.fullPath.substr(2)
    return {
      path,
      replace: true
    }
  } else if (to.name === 'UserOkr' && from.name === 'MyOkrWeek') {
    return `/okr-week/${to.params.userId}`
  } else if (to.name === 'MyOkr' && from.name === 'UserOkrWeek') {
    return '/okr-week/'
  } else if (to.name === 'UserOkr' && from.name === 'UserOkrWeek' && to.params.userId !== from.params.userId) {
    return `/okr-week/${to.params.userId}`
  }
})

router.afterEach((to) => {
  if (to.meta.menu) {
    store.commit(SET_MENU, {
      selectedKeys: [to.meta.menu.key],
      parentKeys: to.meta.menu.parentKey ? [to.meta.menu.parentKey] : []
    })
  } else if (to.name === 'UserOkr' || to.name === 'UserOkrWeek') {
    store.commit(SET_MENU, {
      selectedKeys: [+to.params.userId]
    })
  }
})

export default router
